import Swiper from 'swiper'
import { Keyboard, Navigation } from 'swiper/modules'
import { module as BaseModule } from 'modujs'

import 'swiper/css'

export default class extends BaseModule {
  init() {
    this.lightbox = this.el.querySelector('[data-gallery-lightbox]')
    this.swiperEl = this.el.querySelector('[data-gallery-swiper]')
    this.closeButton = this.el.querySelector('[data-gallery-close]')
    this.triggers = [...this.el.querySelectorAll('[data-gallery-index]')]

    if (!this.lightbox || !this.swiperEl || !this.triggers.length) {
      return
    }

    this.swiper = new Swiper(this.swiperEl, {
      modules: [Navigation, Keyboard],
      slidesPerView: 1,
      spaceBetween: 0,
      loop: this.triggers.length > 1,
      keyboard: {
        enabled: true,
        onlyInViewport: true,
      },
      navigation: {
        nextEl: this.el.querySelector('[data-gallery-next]'),
        prevEl: this.el.querySelector('[data-gallery-prev]'),
      },
    })

    this.onTriggerClick = (event) => {
      const index = Number(event.currentTarget.dataset.galleryIndex)
      this.open(index)
    }

    this.onCloseClick = () => this.close()
    this.onKeydown = (event) => {
      if (event.key === 'Escape') {
        this.close()
      }
    }

    this.triggers.forEach((trigger) => {
      trigger.addEventListener('click', this.onTriggerClick)
    })

    this.closeButton?.addEventListener('click', this.onCloseClick)
    this.lightbox.addEventListener('click', (event) => {
      if (event.target === this.lightbox) {
        this.close()
      }
    })
  }

  open(index) {
    this.lightbox.hidden = false
    this.lightbox.classList.add('is-open')
    this.lightbox.setAttribute('aria-hidden', 'false')
    document.body.classList.add('is-gallery-open')

    if (window.lenis?.stop) {
      window.lenis.stop()
    }

    if (this.swiper.params.loop) {
      this.swiper.slideToLoop(index, 0)
    } else {
      this.swiper.slideTo(index, 0)
    }

    document.addEventListener('keydown', this.onKeydown)
    this.closeButton?.focus()
  }

  close() {
    this.lightbox.hidden = true
    this.lightbox.classList.remove('is-open')
    this.lightbox.setAttribute('aria-hidden', 'true')
    document.body.classList.remove('is-gallery-open')

    if (window.lenis?.start) {
      window.lenis.start()
    }

    document.removeEventListener('keydown', this.onKeydown)
  }

  destroy() {
    document.removeEventListener('keydown', this.onKeydown)

    this.triggers.forEach((trigger) => {
      trigger.removeEventListener('click', this.onTriggerClick)
    })

    this.closeButton?.removeEventListener('click', this.onCloseClick)
    this.close()

    if (this.swiper) {
      this.swiper.destroy(true, true)
      this.swiper = null
    }
  }
}
